import script from "./profit.vue?vue&type=script&setup=true&lang=js"
export * from "./profit.vue?vue&type=script&setup=true&lang=js"

import "./profit.vue?vue&type=style&index=0&id=64c82552&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c82552"]])

export default __exports__